import { CanMatchFn, Router } from '@angular/router';

import { filter, map, take } from 'rxjs';
import { SharedService } from './shared-service';
import { inject } from '@angular/core';

// export const roleGuard: CanMatchFn = async (route, state) => {
//   const sharedService = inject(SharedService);
//   const router = inject(Router);

//   let employeeRoles: string[] = [];
//   employeeRoles =
//     (await firstValueFrom(sharedService.userProfile$))?.roles ?? [];

//   const data = route.data;
//   const { allowedRoles = [], checkType = 'any' } = data || {};
//   if (!allowedRoles.length) return true;

//   const have = new Set(employeeRoles.map((role) => role.toLowerCase()));
//   const need = allowedRoles.map((role: string) => role.toLowerCase());

//   const hasRequiredAccess =
//     checkType === 'all'
//       ? need.every((role: string) => have.has(role))
//       : need.some((role: string) => have.has(role));

//   sharedService.logger('Role Guard' [have, need, hasRequiredAccess, ]);

//   if (hasRequiredAccess) {
//     return hasRequiredAccess;
//   } else {
//     sharedService.errorMessageSubject.next(
//       "You don't have necessary roles to access this page."
//     );
//     return router.createUrlTree(['/error']);
//   }
// };

export const roleGuard: CanMatchFn = (route) => {
  const sharedService = inject(SharedService);
  const router = inject(Router);
  const need = (route.data?.['allowedRoles'] as string[]) ?? [];

  sharedService.logger('Role Guard required roles', need);
  return sharedService.userProfile$.pipe(
    filter((p) => !!p),
    take(1),
    map((p) => {
      sharedService.logger('Role Guard Route profile', p);
      const have = (p!.roles ?? []).map((r) => r.toLowerCase());
      sharedService.logger('Role Guard have roles', have);

      const ok =
        need.length === 0 || need.some((r) => have.includes(r.toLowerCase()));
      sharedService.logger('Role Guard is ok to route?', ok);

      return ok ? true : router.createUrlTree(['/error']);
    })
  );
};
